import { render, staticRenderFns } from "./BasMeasureUnitModal.vue?vue&type=template&id=d544f5c4&scoped=true&"
import script from "./BasMeasureUnitModal.vue?vue&type=script&lang=js&"
export * from "./BasMeasureUnitModal.vue?vue&type=script&lang=js&"
import style0 from "./BasMeasureUnitModal.vue?vue&type=style&index=0&id=d544f5c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d544f5c4",
  null
  
)

export default component.exports